export function getImagePlaceholder(text = "example") {
  const color = Number(
    text
      .replace(/\s+/g, "")
      .split("")
      .map((t) => t.charCodeAt(0))
      .join(""),
  )
    .toString(16)
    .slice(0, 6);
  return `https://placehold.co/700@2x/${color}/white.webp?text=${encodeURI(
    text,
  )}`;
}

export function delay<T>(out: T, time = 1e3) {
  return new Promise((r) => setTimeout(() => r(out), time));
}
export function relativeDate(dateStr: string | undefined): string {
  if (!dateStr) {
    return "No date provided";
  }

  const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "Invalid date";

  const now = Date.now();
  const secondsDiff = Math.round((date.getTime() - now) / 1000);

  const unitsInSec = [
    60,
    3600,
    86400,
    86400 * 7,
    86400 * 30,
    86400 * 365,
    Infinity,
  ];
  const unitStrings = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "year",
  ] as const;

  const unitIndex = unitsInSec.findIndex(
    (cutoff) => cutoff > Math.abs(secondsDiff),
  );
  const divisor = (unitIndex ? unitsInSec[unitIndex - 1] : 1) || 1;

  const relativeTime = rtf.format(
    Math.floor(secondsDiff / divisor),
    unitStrings[unitIndex] || "day",
  );

  return relativeTime;
}
